// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Tpv5","content":"RecentSearches_content__34QnS"};